var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridTextBox',{staticClass:"notranslate",attrs:{"data-qa":"builder-gridelement-text"},on:{"dragstart":function($event){$event.preventDefault();}}},[(_vm.localEditor)?_c('EditorContent',{attrs:{"editor":_vm.localEditor}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }